// extracted by mini-css-extract-plugin
module.exports = {"downloadAppWrapper":"_3UMjU","carImage":"_24h7j","text":"_2DKOI","logo":"_25OgO","postInspectionDiyContainer":"_3XGYb"};